import React from 'react';
import PropTypes from 'prop-types';
import { getUrlString } from '../../../../../utils/shared/urlUtils';
import { getRepeatedWordClassName, isWordRepeated } from '../../../../../utils/shared/trcUtils';
import { getNoteColor, getRightClassName } from './wordUtils';
import { SHARED_API_URL, PARAM } from '../../../../../constants/shared/ApiConstants';

const { PARAM_INK_UID, PARAM_TARGET_WIDTH, PARAM_TARGET_HEIGHT, PARAM_MARKUP, LIN_WIDTH } = PARAM;

const Word = ({ word, nextWord, baseUrl }) => {
    const { INK_URL } = SHARED_API_URL(baseUrl).BASE_URLS;
    const { word: subWord, note, told, inserted } = word;
    return (
        <div className={`trc-word ${getRepeatedWordClassName(word, nextWord)}`}>
            {note && (
                <>
                    <img
                        alt="insert"
                        src={getUrlString(INK_URL, {
                            [PARAM_INK_UID]: note.inkId,
                            [PARAM_MARKUP]: getNoteColor(word, false),
                            [PARAM_TARGET_WIDTH]: '60',
                            [PARAM_TARGET_HEIGHT]: '30',
                            [LIN_WIDTH]: '1',
                        })}
                    />
                    <div className={`word-note ${getNoteColor(word, true)}`} />
                </>
            )}
            <div
                className={`${getRightClassName(word)} ${
                    isWordRepeated(word, nextWord) ? '' : 'not-repeted-padding'
                }`}
            >
                {told ? `(${subWord})` : subWord} {inserted ? `^ ` : ''}
            </div>
        </div>
    );
};

Word.defaultProps = {
    word: {},
    nextWord: {},
    baseUrl: null,
};

Word.propTypes = {
    word: PropTypes.object,
    nextWord: PropTypes.object,
    baseUrl: PropTypes.string,
};

export default Word;
